<!--  -->
<template>
  <div>
    <el-form
      label-position="right"
      label-width="110px"
      style="position:relative"
    >
      <el-form-item
        label="按钮图"
        style="position:relative"
      >
        <div>
          <img
            v-if="novel_button_img"
            style="height: 120px; width: 120px;"
            :src="novel_button_img"
          >
        </div>
        <el-button
          type="primary"
          size="mini"
          @click="aweq('novel_button_img')"
        >素材库选择/上传</el-button>
      </el-form-item>
      <el-form-item
        label="获客链接地址"
        style="position:relative"
      >
        <el-input v-model="huokelink" placeholder="请输入获客链接地址" />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <!-- 上传图片弹窗 -->
    <el-dialog
      title="图片库"
      :visible.sync="dialogVisibletuww"
      width="50%"
      append-to-body
    >
      <TencentCloudChooseimgr
        ref="TencentCloudChooseimgrview"
        @clickicon="chuantu"
      />
    </el-dialog>
  </div>
</template>

<script>
import TencentCloudChooseimgr from '../../miniservice/components/TencentCloudChooseimg.vue'
export default {
  components: { TencentCloudChooseimgr },
  data() {
    return {
      novel_button_img: '',
      huokelink: '',
      dialogVisibletuww: false
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    aweq(type) {
      this.dialogVisibletuww = true
      setTimeout(() => {
        // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.TencentCloudChooseimgrview.parentHandleclick('1')
      }, 100)
    },
    chuantu(img) {
      this.dialogVisibletuww = false
      this.novel_button_img = img
    },
    sumbitr() {
      if (this.novel_button_img === '') {
        this.$message.error('请选择按钮图片')
        return
      }
      if (this.huokelink === '') {
        this.$message.error('请输入获客链接')
        return
      }
      this.$emit('callbackhuoke', this.novel_button_img, this.huokelink)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
